export const RATE_TYPES = [
  {
    name: 'Spot',
    abbr: 'spot',
  },
  {
    name: 'Contract Primary',
    abbr: 'contract_primary',
  },
  {
    name: 'Backup Published',
    abbr: 'contract_backup',
  },
  {
    name: 'Spot + Backup Published',
    abbr: 'spot_backup',
  },
  {
    name: 'Contract + Backup Published',
    abbr: 'primary_backup',
  },
]

export const RATE_TYPE_KEYS_TO_NAMES = {
  spot: 'Spot',
  contract_primary: 'Contract Primary',
  contract_backup: 'Backup Published',
  spot_backup: 'Spot + Backup Published',
  primary_backup: 'Contract + Backup Published',
} as { [key: string]: string }
